//
//
//
//

import {fetch,promptMessage} from '@/api/dataHandling.js';
import {urlConfig} from '@/api/urlConfig.js';
import {getken} from '@/api/getToken';
  export default {
      data(){
          return{

          }
      },
      components: {},
      computed: {},
      methods: {
        getUserId(){
          if(this.$route.query.openid){
            fetch('get',urlConfig.GetSfzh +'?openid='+this.$route.query.openid).then(response => {
              this.getPersonInfoId(response.sfzh);
            }).catch(error => {


            })
          }else {
            promptMessage('提示','请先关注武汉锦欣中西医结合妇产医院微信公众号!');
            window.location.href="http://app.cdxt.com.cn/scvif/pages/pubCheckHasReg.html";
          }

        },
        getPersonInfoId(sfzh){
          fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
            this.getRole(response.personInfoId)
          }).catch(error => {

          })

        },
        getRole(personInfoId){
          console.log(urlConfig.getonlineRoleurl+ personInfoId,444)
          fetch('get',urlConfig.getonlineRoleurl + personInfoId).then(response => {
            console.log(response,4545)
            fetch('get',urlConfig.onlineGetUserurl).then(res => {
              if(response.length !=0){  //如果是医生
                this.$router.push({path:'patientList',query:{'personId':personInfoId,openid:this.$route.query.openid,id:res[0].PERSON_ID}});
              }else {   //如果是患者
                fetch('get',urlConfig.getpatienMsg +'?openid='+this.$route.query.openid).then(response => {
                  for(let i in response){
                       if(response[i] == null){
                         response[i] = '';
                       }
                  }
                  this.paramsData = {
                    doctorPersonInfoId: res[0].PERSON_ID,
                    patientPersonInfoId: personInfoId,
                    quantity: 1,
                    status: 1,
                    title: response.patientName+','+ response.sXbDm + ',' + response.age + ',' + response.brly + ',' + response.tjrxm,
                    type: 1,
                    unitPrice: 0
                  };

                  fetch('post',urlConfig.onlinepatienorderurl,this.paramsData).then(response => {
                    this.$router.push({path:'/patientChatWindow',query:{'personId':personInfoId,isdoctor:0,openid:this.$route.query.openid,id:response.id}});
                  }).catch(error => {
                  })

                }).catch(error => {

                })
              }
            }).catch(error => {

            })

          }).catch(error => {

          })

        }, //判断角色
      },
      mounted(){
        getken(this.getUserId);
        this.$store.commit('updateLoadingStatus',{isLoading:true});

      }
  }



// WEBPACK FOOTER //
// ./src/project/onlineServicesProject/onlineIndex.vue